import { useEffect } from "react";

import { useAnalytics } from "@accurx/analytics";
import { useCurrentWorkspace } from "@accurx/auth";
import { Ds, Feedback } from "@accurx/design";
import { useNavigationOrigin } from "@accurx/navigation";
import { useDispatch } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";

import { StyledContainer } from "app/layout/Container";
import { PageHeader, PageHeaderType } from "app/layout/PageHeader";
import { getPatientTriageStatus } from "app/practices/patientTriage/PatientTriage.actions";

import { PatientTriageSettingsContainer } from "../components/PatientTriageSettings.container";
import { useDefaultCopiesQuery } from "../useDefaultCopiesQuery";

export const PatientTriageSettingsPage = () => {
    const track = useAnalytics();
    const navigationOrigin = useNavigationOrigin();

    const dispatch = useDispatch();
    const history = useHistory();
    const match = useRouteMatch();
    const { orgId, organisationName, nationalCode } = useCurrentWorkspace();

    const { status, data: defaultCopies } = useDefaultCopiesQuery({
        nationalCode,
    });

    useEffect(() => {
        track("PatientTriageSetting Page View", { navigationOrigin });
    }, [track, navigationOrigin]);

    useEffect(() => {
        /**
         * Temporary: Data is fetched in this parent wrapper rather than the container to replicate the same behaviour
         * as the PatientTriage component in Manage Org.
         */
        dispatch(getPatientTriageStatus(String(orgId)));
    }, [dispatch, orgId]);

    return (
        <StyledContainer>
            <PageHeader title="Settings" type={PageHeaderType.ListPage} />
            {status === "loading" && <Ds.Spinner />}
            {status === "error" && (
                <Feedback
                    title="Unable to load default copies, please try again"
                    colour="error"
                />
            )}
            <PatientTriageSettingsContainer
                history={history}
                location={history.location}
                match={match}
                practiceId={orgId.toString()}
                practiceName={organisationName}
                defaultCopies={defaultCopies}
            />
        </StyledContainer>
    );
};
